import { selectAccessToProtectedRoutes } from '../store/auth/selectors';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from '../store/store';
import { FC } from 'react';

export const ProtectedRoute: FC = () => {
    const hasAccess = useSelector(selectAccessToProtectedRoutes);
    return (hasAccess ? <Outlet /> : <Navigate to='/workspace' />);
};